import virtualClassesRepo from './virtualClasses'
import assignmentsRepo from './assignments'
import assessmentsRepo from './assessments'
export default {
  virtualClasses: virtualClassesRepo,
  assignmentsRepo,
  assessmentsRepo
}